import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { AttendanceCustomTimeRangeDayEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import Block from 'modules/attendance/components/CustomTimeRanges/Content/Table/CompensationTabBody/Block'
import HoverButton from 'modules/attendance/components/CustomTimeRanges/Content/Table/CompensationTabBody/HoverButton'
import { CustomTimeRange } from 'modules/attendance/hooks/useFetchCustomTimeRanges'

interface ContentProps {
  timeRanges: CustomTimeRange[]
  base: boolean
  dayType: AttendanceCustomTimeRangeDayEnum
  hover: boolean
  showNotDefined: boolean
  settingId: number
}

const Content = ({ timeRanges, base, dayType, hover, showNotDefined, settingId }: ContentProps) => {
  if (!!timeRanges.length) return <Block timeRanges={timeRanges} base={base} />

  if (showNotDefined) {
    if (hover) return <HoverButton dayType={dayType} settingId={settingId} />

    return (
      <Box paddingY="s16">
        <Text.Normal color="grey600" ellipsis>
          {i18n.t('time_tracking.settings.custom_time_range_section.not_defined')}
        </Text.Normal>
      </Box>
    )
  }

  return <Box padding="s24" alignItems="center" width="s200" />
}

export default Content
